import QueryString from "qs";
import LocalStorage, { LocalStorageKey } from "../LocalStorage";

export default class SearchHelper {
  static getSearch(queryString: string, filterWhiteList: string[]) {
    // qs converts arrays with more than 20 items (default arrayLimit) into objects, which breaks "in" filters
    const parameters = QueryString.parse(queryString, { ignoreQueryPrefix: true, arrayLimit: 1000 });

    const search = String(parameters.search || "");
    const page = Number(parameters.page || 1);
    const perPage = Number(parameters.perPage || LocalStorage.get(LocalStorageKey.PER_PAGE, 25));

    const filters = {}

    for (const key in parameters) {
      if (filterWhiteList.includes(key)) {
        filters[key] = parameters[key];
      }
    }

    return {
      search: search,
      page: page,
      filters: filters,
      perPage: perPage
    };
  }

  // static getSearchParams(page: string, search: string, filters: any) {
  //   return {
  //     page: number,
  //     search: search,
  //     filters: filters,
  //   }
  // }

  static getFilterParams(search: string, filters: any) {
    return {
      search: search,
      filters: filters
    }
  }

  static getQueryString(params = {}) {
    return QueryString.stringify(params, {
      arrayFormat: "brackets",
      indices: false,
      skipNulls: true
    });
  }
}

